/* Nerd kiwi variant — pixel glasses with square lenses. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderNerd(p: KiwiPalette) {
  return (
    <>
      {/* Body */}
      <path d="M12 6H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V6Z" fill={p.body} />
      {/* Highlight */}
      <rect x="20" y="10" width="2" height="2" fill={p.highlight} opacity={0.3} />
      <rect x="22" y="12" width="2" height="2" fill={p.highlight} opacity={0.2} />
      {/* Beak */}
      <path d="M4 12H6V14H4V12ZM2 14H4V16H2V14ZM2 16H4V18H2V16ZM4 18H6V20H4V18Z" fill={p.beak} />
      {/* Tuft feathers */}
      <path d="M10 4H12V6H10V4ZM8 2H10V4H8V2ZM12 2H14V4H12V2Z" fill={p.body} />
      {/* Glasses lenses */}
      <rect x="8" y="10" width="4" height="6" fill={p.eyeBg} />
      <rect x="13" y="10" width="4" height="6" fill={p.eyeBg} />
      {/* Glasses bridge */}
      <rect x="12" y="12" width="1" height="2" fill={p.accent} opacity={0.5} />
      {/* Glasses rim */}
      <rect x="7" y="9" width="6" height="1" fill={p.accent} opacity={0.5} />
      <rect x="7" y="16" width="6" height="1" fill={p.accent} opacity={0.5} />
      <rect x="7" y="9" width="1" height="8" fill={p.accent} opacity={0.5} />
      <rect x="13" y="9" width="1" height="8" fill={p.accent} opacity={0.5} />
      <rect x="14" y="9" width="4" height="1" fill={p.accent} opacity={0.5} />
      <rect x="14" y="16" width="4" height="1" fill={p.accent} opacity={0.5} />
      <rect x="18" y="9" width="1" height="8" fill={p.accent} opacity={0.5} />
      {/* Pupils */}
      <rect x="10" y="12" width="2" height="2" fill={p.pupil} />
      <rect x="15" y="12" width="2" height="2" fill={p.pupil} />
      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
